import { render } from "./FileManagerUploadPreview.vue?vue&type=template&id=ba39a510"
import script from "./FileManagerUploadPreview.vue?vue&type=script&lang=js"
export * from "./FileManagerUploadPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__